@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load your assignments" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (VM) {
<section class="oep-revs" [attr.aria-busy]="Busy">
  <!-- markup.html:494-495 -->
  <h1 class="oep-h1">Review draft presentations</h1>
  <p class="oep-lead">{{ VM.Intro }}</p>

  <!-- before Matched: no assignment is visible yet (2026-10-19 §5.2) -->
  @if (VM.BeforeMatching; as b) {
    <div class="oep-card oep-revs__callout"><p class="oep-revs__callout-text">{{ b }}</p></div>
  }

  <!-- markup.html:497-507 -->
  @if (VM.Pending; as p) {
    <div class="oep-card oep-revs__callout">
      <h2 class="oep-revs__callout-title">{{ p.Title }}</h2>
      <p class="oep-revs__callout-text">{{ p.Text }}</p>
      @if (p.Links.length) {
        <ul class="oep-revs__links">
          @for (l of p.Links; track l.Url) { <li><a [href]="l.Url" target="_blank" rel="noopener">{{ l.Label }}<span class="oep-sr"> (opens in a new tab)</span></a></li> }
        </ul>
      }
    </div>
  }

  <!-- markup.html:509-519 -->
  @if (VM.Wrap; as w) {
    <div class="oep-card oep-revs__callout oep-revs__callout--done">
      <h2 class="oep-revs__callout-title">{{ w.Title }}</h2>
      <p class="oep-revs__callout-text">{{ w.Text }}</p>
    </div>
  }

  <!-- markup.html:521-526 -->
  @if (VM.Guidance; as g) {
    <div class="oep-revs__guidance">
      <h2 class="oep-revs__guidance-title">{{ g.Title }}</h2>
      <p>{{ g.Text }}</p>
    </div>
  }

  <!-- markup.html:528-548 -->
  @if (VM.Rows.length === 0 && !VM.BeforeMatching) {
    <mj-empty-state Variant="empty" Title="No assignments yet" Message="If you expected one, reply to your OEP email or write to membership@agu.org." />
  }
  <ul class="oep-revs__list">
    @for (r of VM.Rows; track r.AssignmentID) {
      <li class="oep-card oep-revs__row" [attr.aria-labelledby]="'oep-as-' + r.AssignmentID">
        <div class="oep-revs__body">
          <span class="oep-eyebrow">{{ r.Header }}</span>
          <h2 class="oep-revs__title" [id]="'oep-as-' + r.AssignmentID">{{ r.Title }}</h2>
          @if (r.Sub) { <div class="oep-revs__sub">{{ r.Sub }}</div> }
          @if (r.Due) { <div class="oep-revs__due" [attr.data-tone]="r.DueTone">{{ r.Due }}</div> }
        </div>
        <div class="oep-revs__side">
          <span class="oep-badge" [attr.data-tone]="r.Tone">{{ r.Status }}</span>
          <button type="button" mjButton [variant]="r.CtaEnabled ? 'primary' : 'outline'" class="oep-revs__cta" [disabled]="!r.CtaEnabled" (click)="Open(r)">{{ r.Cta }}</button>
          @if (r.Draft; as d) {
            <button type="button" class="oep-revs__link" (click)="Download(r)">{{ d.Label }}</button>
          }
        </div>
      </li>
    }
  </ul>
  <p class="oep-revs__status" role="status" aria-live="polite" [attr.data-tone]="Status?.Tone">{{ Status?.Text }}@if (Status?.Link; as l) { <a [href]="l.Url" target="_blank" rel="noopener">{{ l.Label }}<span class="oep-sr"> (opens in a new tab)</span></a> }</p>
</section>
}
